define("shared/components/shared/ui/education", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @backdrop={{false}} @closable={{false}} as |modal|>
    <modal.card class={{@className}}>
      <modal.card-body class="u--p__t__0">
        {{#if (user-agent "device.isMobile")}}
          <img
            alt={{t "linkinbio.get_started.section_one_title"}}
            class="o--media"
            src="/assets/images/img--libOnboarding--education.png"
          />
        {{/if}}
        <div class="u--row u--row--noCollapse">
          {{! Description }}
          <div class="u--col__6 u--col__push--6 cLB--contentWidth">
            {{! Modal Header }}
            <modal.card-header class={{if (user-agent "device.isDesktop") "" "u--p__tb__0"}}>
              {{#if @showBetaLabel}}
                <Shared::Badge
                  @className="cVL--badge is--beta u--m__b__xs"
                  @href="https://help.later.com/hc/articles/5257013227031"
                />
              {{/if}}
              <p class="o--modalHeader__title u--text--lg {{@titleQaClass}}">
                {{@title}}
              </p>
            </modal.card-header>
            {{! Modal Body }}
            <modal.card-body class={{if (user-agent "device.isDesktop") "" "u--p__t__0"}}>
              {{! Sub Title }}
              {{#if (has-block)}}
                {{yield}}
              {{else}}
                <p class="u--text--md">
                  {{@body}}
                </p>
              {{/if}}
              {{! Buttons }}
              <div class="u--row {{if (user-agent 'device.isDesktop') 'u--p__t__lg' 'u--p__t'}}">
                <div class="u--col__12">
                  {{#if @link}}
                    <a
                      class="o--btn--lg o--btn--outline o--btn--block {{@learnMoreQaClass}}"
                      href={{@link}}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      {{t "shared_phrases.learn_more"}}
                    </a>
                  {{/if}}
                  {{#if @needsUpgrade}}
                    <Shared::Button::Upgrade
                      @additional="block"
                      @feature={{@feature}}
                      @location={{@location}}
                      @size="large"
                      @text={{@text}}
                      @track={{@track}}
                      class="u--p__lr"
                    />
                  {{else}}
                    <a class="o--btn--lg o--btn--primary o--btn--block {{@actionQaClass}}" onclick={{@actionMethod}}>
                      {{@actionText}}
                    </a>
                  {{/if}}
                </div>
              </div>
            </modal.card-body>
          </div>
        </div>
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "OkKZpZZG",
    "block": "[[[8,[39,0],null,[[\"@backdrop\",\"@closable\"],[false,false]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[16,0,[30,2]]],null,[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],[[24,0,\"u--p__t__0\"]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[28,[37,2],[\"device.isMobile\"],null],[[[1,\"        \"],[10,\"img\"],[15,\"alt\",[28,[37,3],[\"linkinbio.get_started.section_one_title\"],null]],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--libOnboarding--education.png\"],[12],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n\"],[1,\"        \"],[10,0],[14,0,\"u--col__6 u--col__push--6 cLB--contentWidth\"],[12],[1,\"\\n\"],[1,\"          \"],[8,[30,1,[\"card-header\"]],[[16,0,[52,[28,[37,2],[\"device.isDesktop\"],null],\"\",\"u--p__tb__0\"]]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[30,3],[[[1,\"              \"],[8,[39,4],null,[[\"@className\",\"@href\"],[\"cVL--badge is--beta u--m__b__xs\",\"https://help.later.com/hc/articles/5257013227031\"]],null],[1,\"\\n\"]],[]],null],[1,\"            \"],[10,2],[15,0,[29,[\"o--modalHeader__title u--text--lg \",[30,4]]]],[12],[1,\"\\n              \"],[1,[30,5]],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n\"],[1,\"          \"],[8,[30,1,[\"card-body\"]],[[16,0,[52,[28,[37,2],[\"device.isDesktop\"],null],\"\",\"u--p__t__0\"]]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[48,[30,17]],[[[1,\"              \"],[18,17,null],[1,\"\\n\"]],[]],[[[1,\"              \"],[10,2],[14,0,\"u--text--md\"],[12],[1,\"\\n                \"],[1,[30,6]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]]],[1,\"            \"],[10,0],[15,0,[29,[\"u--row \",[52,[28,[37,2],[\"device.isDesktop\"],null],\"u--p__t__lg\",\"u--p__t\"]]]],[12],[1,\"\\n              \"],[10,0],[14,0,\"u--col__12\"],[12],[1,\"\\n\"],[41,[30,7],[[[1,\"                  \"],[10,3],[15,0,[29,[\"o--btn--lg o--btn--outline o--btn--block \",[30,8]]]],[15,6,[30,7]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n                    \"],[1,[28,[35,3],[\"shared_phrases.learn_more\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],null],[41,[30,9],[[[1,\"                  \"],[8,[39,7],[[24,0,\"u--p__lr\"]],[[\"@additional\",\"@feature\",\"@location\",\"@size\",\"@text\",\"@track\"],[\"block\",[30,10],[30,11],\"large\",[30,12],[30,13]]],null],[1,\"\\n\"]],[]],[[[1,\"                  \"],[10,3],[15,0,[29,[\"o--btn--lg o--btn--primary o--btn--block \",[30,14]]]],[15,\"onclick\",[30,15]],[12],[1,\"\\n                    \"],[1,[30,16]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]]],[1,\"              \"],[13],[1,\"\\n            \"],[13],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"@className\",\"@showBetaLabel\",\"@titleQaClass\",\"@title\",\"@body\",\"@link\",\"@learnMoreQaClass\",\"@needsUpgrade\",\"@feature\",\"@location\",\"@text\",\"@track\",\"@actionQaClass\",\"@actionMethod\",\"@actionText\",\"&default\"],false,[\"shared/modal\",\"if\",\"user-agent\",\"t\",\"shared/badge\",\"has-block\",\"yield\",\"shared/button/upgrade\"]]",
    "moduleName": "shared/components/shared/ui/education.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});